import { createSlice } from '@reduxjs/toolkit'

import { socket } from 'store/socket'

import { useAppDispatch, useAppSelector } from '../hooks'

const INITIAL_SOCKET_STATE = {}

const socketSlice = createSlice({
  name: 'socket',
  initialState: INITIAL_SOCKET_STATE,
  reducers: {
    openProductConnection(state, action) {
      socket.connect()

      const callback = action.payload as (companyId: number) => void
      socket.on('delete-product', callback)
    },
    openCompetitorConnection(state, action) {
      socket.connect()

      const callback = action.payload as (companyId: number) => void
      socket.on('delete-competitor', callback)
    },
    closeProductConnection(state) {
      socket.off('delete-product')
      socket.disconnect()
    },
    closeCompetitorConnection(state) {
      socket.off('delete-competitor')
      socket.disconnect()
    },
  },
})

const { actions, reducer } = socketSlice

export default reducer

export const {
  openProductConnection,
  openCompetitorConnection,
  closeProductConnection,
  closeCompetitorConnection,
} = actions

export const useSocketState = (): typeof INITIAL_SOCKET_STATE =>
  useAppSelector((state) => state.socket)

export const useSocketActions = () => {
  const dispatch = useAppDispatch()

  return {
    openProductConnection: (payload: (companyId: number) => void) =>
      dispatch(openProductConnection(payload)),
    openCompetitorConnection: (payload: (companyId: number) => void) =>
      dispatch(openCompetitorConnection(payload)),
    closeProductConnection: () => dispatch(closeProductConnection()),
    closeCompetitorConnection: () => dispatch(closeCompetitorConnection()),
  }
}
